import axios, { type AxiosError } from 'axios';
import posthog from 'posthog-js';

import config from '../config/config';

declare const VERSION: string;

const getHeroProductByStore = async ({
  storeId,
  productType
}: {
  storeId: string;
  productType?: string;
}): Promise<string | undefined> => {
  const url = `${
    config.publicApi.enabled ? config.publicApi.url : config.api.url
  }/api/public/stores/${storeId}/product-configuration/hero-product/`;

  try {
    const response = await axios.get(url, {
      params: {
        productType
      }
    });
    return response?.data?.data;
  } catch (e) {
    const error = e as AxiosError;
    posthog?.capture('getHeroProductByStoreFailed', { error: error.toJSON(), version: VERSION });
    console.error((e as Error).message);
  }
};

export default getHeroProductByStore;
